<div class="modal-header">
  <h4 class="modal-title pull-left">
    <app-icon icon="package" iconClass="button-icon"></app-icon> Add Promo Code
  </h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>

@if (promoAlreadyExists) {
  <p class="alert alert-danger">
    Promo Code named <b>"{{ newPromoForm.get('promo_code').value }}"</b> already exists.
  </p>
}
<div class="modal-body">
  <form class="form-horizontal" [formGroup]="newPromoForm" novalidate>
    <div class="form-group">
      <label class="col-sm-3 control-label">Code Name</label>
      <div class="col-sm-9">
        <input type="text" class="form-control fs-block" placeholder="Promo Code" formControlName="promo_code">
        @if (newPromoForm.get('promo_code').invalid && newPromoForm.get('promo_code').touched) {
          <div class="form-error">
            <p>Code is required</p>
          </div>
        }
      </div>
    </div>
    <div class="form-group">
      <label for="discount_type" class="col-sm-3 control-label">Discount Type</label>
      <div class="col-sm-9">
        <select class="form-control" formControlName="discount_type" [ngClass]="{ 'placeholder' : !newPromoForm.get('discount_type').value }">
          <option class="" selected="" disabled="" value="">Discount Type</option>
          @for (type of discountTypes; track type) {
            <option [value]="type.value">
              {{type.title}}
            </option>
          }
        </select>
        @if (newPromoForm.get('discount_type').invalid && newPromoForm.get('discount_type').touched) {
          <div class="form-error">
            <p>Promo type is required</p>
          </div>
        }
      </div>
    </div>
    @if (newPromoForm.get('discount_type').value) {
      <div class="form-group">
        <div class="col-sm-9 col-sm-offset-3">
          <div class="input-group">
            @if (newPromoForm.get('discount_type').value === 'dollar_amount') {
              <span class="input-group-addon">$</span>
            }
            <input type="number" class="form-control"
              placeholder="{{ newPromoForm.get('discount_type').value === 'percentage_off' ? 'Percentage' : 'Dollars' }}" formControlName="discount">
            @if (newPromoForm.get('discount_type').value === 'percentage_off') {
              <span class="input-group-addon">%</span>
            }
          </div>
          @if (newPromoForm.get('discount').invalid &&
            newPromoForm.get('discount').touched && newPromoForm.get('discount_type').value === 'dollar_amount') {
            <div class="form-error">
              <p>Amount cannot be negative</p>
            </div>
          }
          @if (newPromoForm.get('discount').invalid &&
            newPromoForm.get('discount').touched && newPromoForm.get('discount_type').value === 'percentage_off') {
            <div class="form-error">
              <p>Percentage should be between 0 and 100</p>
            </div>
          }
        </div>
      </div>
    }
    <div class="form-group">
      <label for="discount_type" class="col-sm-3 control-label">Description (Optional)</label>
      <div class="col-sm-9">
        <textarea class="form-control" formControlName="description" rows="5" placeholder="For eg. 10% OFF, $5 OFF etc">
        </textarea>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>
  <button type="button" class="btn btn-primary" [disabled]="newPromoForm.invalid" (click)="addNewPromoCode()">
    Save Changes
  </button>
</div>
